import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  FETCH_SUPPORTTYPE_ACTION,
  FETCH_SUPPORTTYPE_SUCCESS_ACTION,
  FETCH_SUPPORTTYPE_FAIL_ACTION,
  ADD_SUPPORT_ACTION,
  ADD_SUPPORT_SUCCESS_ACTION,
  ADD_SUPPORT_FAIL_ACTION,
  FETCH_SUPPORTCENTER_ACTION,
  FETCH_SUPPORTCENTER_SUCCESS_ACTION,
  FETCH_SUPPORTCENTER_FAIL_ACTION,
} from "./action";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchsupporttype(action) {
  try {
    const token = localStorage.getItem("token");
    let res = yield fetch(appConfig.ip + "/supportType?isActive=true", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      let resJSON = yield res.json();
      let supportType = resJSON.rows.map((data) => {
        let supportTypes = {
          value: data.id,
          name: data.name,
        };
        return supportTypes;
      });

      yield put({
        type: FETCH_SUPPORTTYPE_SUCCESS_ACTION,
        payload: resJSON,
        supportType: supportType,
      });
     
    }
  } catch (err) {
    yield put({
      type: FETCH_SUPPORTTYPE_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchsupportCenter(params) {
  const token = localStorage.getItem("token");
  let page = (params.params && params.params.page) || 1;
  let search = (params.params && params.params.search) || "";
  let filter = (params.params && params.params.filter) || "";
  let statusFilter = (params.params && params.params.statusFilter) || "";
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.id;
  let filterParam = "";
  let statusFilterParam = "";
  if (filter) {
    filterParam = `&subject=${filter}`;
  }
  if (statusFilter) {
    statusFilterParam = `&status=${statusFilter}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/support?userId=${id}&limit=10&page=${page}&ser=${search}${filterParam}${statusFilterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_SUPPORTCENTER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_SUPPORTCENTER_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* addsupport(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));




  const supportValue = {
    desc: value.value.desc,
    subject: value.value.subject,
    orgId: user.orgId,
    userId: user.id,
  };
 
  try {
    const res = yield fetch(`${appConfig.ip}/support`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(supportValue),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: ADD_SUPPORT_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Support Added successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: FETCH_SUPPORTCENTER_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_SUPPORT_FAIL_ACTION,
        error: err,
      });
    }
  }
}

export function* SupportCenteActionWatcher() {
  yield takeEvery(FETCH_SUPPORTTYPE_ACTION, fetchsupporttype);
  yield takeEvery(FETCH_SUPPORTCENTER_ACTION, fetchsupportCenter);
  yield takeEvery(ADD_SUPPORT_ACTION, addsupport);
}
